/**
 * @file Contains helper functions for ComposeModalFooter component
 */

import {
  ComposeNodeId,
  ComposeNodeType,
} from '../../../../containers/compose/props';
import translate from '../../../../i18n/translate';
import { ComposeTypeParam } from '../../../../models/pageParams';

/**
 * Get label for create compose button
 *
 * @param composeType Type of the compose form (post or task)
 * @param nodeId      ID of the node
 * @param nodeType    Type of the node (MESSAGE or TEMPLATE)
 *
 * @returns           Label for the button
 */
export const getCreateButtonLabel = (
  composeType: ComposeTypeParam | null,
  nodeId: ComposeNodeId,
  nodeType: ComposeNodeType,
) => {
  const isPost = composeType === 'post';
  if (nodeType === 'MESSAGE') {
    return translate(isPost ? 'COMPOSE__TITLE' : 'TASK__CREATE');
  }

  if (nodeId === null) {
    return translate(
      isPost ? 'POST_TEMPLATE__CREATE' : 'TASK_TEMPLATE__CREATE',
    );
  }

  return translate('SETTINGS__TEMPLATES__COMPOSE__EDIT');
};
